import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import FieldText from '../common/FieldText';
import FieldSelect from '../common/FieldSelect';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import MassSmsAPI from '../../api/MassSmsAPI';
import ValidationController from '../../controller/ValidationController';
import ApiUiController from '../../controller/ApiUiController';
import ViewController from "../../controller/ViewController";

class MassSmsPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_sms;
    this.mass_sms = {
      id: 0, name: "", template: 0, config: 0, operation_status: 1,
      module: props.model_no
    };
    this.state = { inApiCall: false, inValid: {}, mass_sms: { ...this.mass_sms } };
  }

  onChange = (field, value) => {
    const mass_sms = { ...this.state.mass_sms };
    mass_sms[field] = value;
    this.setState({ ...this.state, mass_sms: { ...mass_sms } });
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.mass_sms);
    if (inValid === null) {
      const mass_sms = { ...this.state.mass_sms };
      const mainFilters = ViewController.getRestrictionsView(this.props.model_no);
      let filters = ViewController.filters(this.props.listFilters, this.props.viewFilters, mainFilters, this.props.restrict);
      filters = filters.filter(ele => ele.field !== 'sms_opt');
      mass_sms.filters = filters;
      filters.push({ field: 'sms_opt', type: 'toggle', condition: 'in', value: '' });
      MassSmsAPI.save(mass_sms, this.onSaved, this.onFail);
      this.setState({ ...this.state, inApiCall: true });
    } else { 
      this.setState({ ...this.state, inValid: { ...inValid } }); 
    }
  }

  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };

  onSaved = res => {
    Util.showNotification('Successful', 'Mass SMS saved successfully', 'success');
    this.setState({ ...this.state, mass_sms: { ...this.state.mass_sms, id: res.id }, inApiCall: false });
    this.props.onHide();
    if (this.props.reload) {
      this.props.reload();
    }
  }

  render() {
    const fields = this.model.fields;
    const mass_sms = this.state.mass_sms;
    const inValid = this.state.inValid;
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false}>

        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Send Mass SMS</Modal.Title>
        </Modal.Header>
        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Body>
            <Form>
              <FieldText key="name" id="name" field={fields.name}
                value={mass_sms.name} onValueChange={this.onChange} inValid={inValid} />

              <FieldSelect key="template" id="template"
                field={fields.template} value={mass_sms.template}
                onValueChange={this.onChange} inValid={inValid} />

              <FieldSelect key="config" id="config"
                field={fields.config} value={mass_sms.config}
                onValueChange={this.onChange} inValid={inValid} />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSave}>Submit</Button>
          </Modal.Footer>
        </ApiUiController>
      </Modal>
    );
  }
}
export default MassSmsPopup;